import React, { useEffect, useRef, useState } from 'react';
import { supabaseClient } from '../../services/supabase';
import { useScrollFadeIn } from '../../utils/scrollFadeIn';

// デフォルトのこだわり項目（データベースにデータがない場合のフォールバック）
const defaultKodawariItems = [
  {
    image_url: '/images/neta.jpg',
    title: '◆厳選の魚',
    description: '毎日市場から仕入れる新鮮な魚介類。旬の味わいをお届けします。'
  },
  {
    image_url: '/images/syokunin.jpg',
    title: '◆職人の技',
    description: '20年の経験と技術で、最高の一貫を提供いたします。'
  },
  {
    image_url: '/images/kome.jpg',
    title: '◆こだわりのシャリ',
    description: '北海道産ななつぼしを使用。ほどける食感をご堪能ください。'
  }
];

function Kodawari() {
  const sectionRef = useRef(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // データベースからこだわり項目を取得
  useEffect(() => {
    const loadItems = async () => {
      try {
        const { data, error } = await supabaseClient
          .from('kodawari_items')
          .select('*')
          .eq('is_visible', true)
          .order('display_order', { ascending: true });

        if (error) throw error;

        if (data && data.length > 0) {
          setItems(data);
        } else {
          setItems(defaultKodawariItems);
        }
      } catch (error) {
        console.error('こだわり読み込みエラー:', error);
        setItems(defaultKodawariItems);
      } finally {
        setLoading(false);
      }
    };

    loadItems();
  }, []);

  useScrollFadeIn(sectionRef, '.kodawari-item', [loading, items]);

  if (loading) {
    return (
      <section id="kodawari" className="kodawari" ref={sectionRef}>
        <div className="container">
          <h2 className="section-title">こだわり</h2>
          <p style={{ textAlign: 'center' }}>読み込み中...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="kodawari" className="kodawari" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">こだわり</h2>
        <div className="kodawari-grid">
          {items.map((item, index) => (
            <div key={item.id || index} className="kodawari-item fade-in">
              <div className="kodawari-image">
                <img src={item.image_url} alt={item.title} />
                <div className="kodawari-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Kodawari;
